var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishlist = function SvgWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10 20-1.401-1.518C3.399 13.482 0 10.111 0 5.976 0 2.612 2.402 0 5.497 0 7.202 0 8.901.871 10 2.283 11.099.87 12.797 0 14.502 0 17.598 0 20 2.612 20 5.976c0 4.135-3.399 7.506-8.599 12.506z"
  })));
};
export { SvgWishlist as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvd2lzaGxpc3QuY2U4OWE1ZGIuc3ZnIjs=";